<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9nYADB/tc-custom/9781398464438.jpg?1670934358349" alt="This image is the cover for the book Isabella"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Isabella
      </h1>
      <p class="bookDescription body article font2">
        <p>Isabella is a novel of its time when life was hard and intimidating, often short and frequently brutal in the cause of making many rich men even richer on both sides of the Atlantic. Even so, there were more people willing to stand up to legislate for the cause in America just as happened in Great Britain 50 years earlier to help the oppressed escape to live a better life. <br/>It is a story of love during the Civil War when unlikely people made individual efforts to play a part in overcoming slavery. The story alternates between gunrunning on the Eastern Seaboard, a rescued slave’s efforts to repay society in Boston and Canada and a wealthy young lady’s adventure up the Mississippi taking a young girl to Canada for safety and her involvement with the underground railway.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael John
      </h2>
      
      <p class="authorDescription body article">Michael John is a retired Master Mariner. In a full career at sea he commanded a wide range of ships across the world. <br>Isabella is his second novel of three published books. Much of the historical background has been drawn from family records. <br>Michael John has a daughter, twin sons and seven grandchildren <br>He sails his own traditional boat and lives on the river Tamar.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c2ef844a